module.exports = __webpack_public_path__ + "static/media/books.aa725320.jpg";